<template>
  <div class="hatful-footer">
    <div class="fotter-box">
      <div class="list-box">
        <div class="item">
          <div class="listActive">About</div>
          <div class="list" @click="selectMenu(2)" style="cursor: pointer;">Privacy policy</div>
          <div class="list" @click="selectMenu(3)" style="cursor: pointer;">Contact Us</div>
        </div>
        <div class="item">
          <div class="listActive">Contact</div>
          <div class="list">HATFUL LIMITED</div>
          <div class="list">happyandlivelyfanzi@gmail.com</div>
        </div>
      </div>
      <div class="work">
        <img src="../assets/logo-1.png" alt="">
        <div class="imgs">
          <img src="../assets/logo-2.png" alt="">
          <img src="../assets/logo-3.png" alt="">
        </div>
      </div>
    </div>
    <div class="fotter-info">
      <div class="tel">
        <p>©2024 All rights HATFUL LIMITED</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 1
    };
  },
  methods: {
    selectMenu(value) {
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "projects" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;

        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.hatful-footer {
  border-top: 3px solid #363536;
  padding: 30px 305px;
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  background: #191A20;

  .fotter-box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .list-box {
      display: flex;

      .item {
        margin-right: 150px;

        .listActive {
          margin-bottom: 24px;
          font-size: 24px;
          font-family: Roboto, Roboto;
          font-weight: 600;
          color: #FFFFFF;
        }

        .list {
          margin-bottom: 24px;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }

    .work {
      img {
        margin-bottom: 23px;
        width: 246px;
        height: 33px;
      }

      .imgs {
        img {
          margin-right: 24px;
          width: 115px;
          height: 41px;
        }
      }
    }
  }

  .fotter-info {
    margin-top: 40px;

    .tel {
      margin-right: 80px;

      p {
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}
</style>
